import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

function CardHeader({ children, className, ...props }) {
  return (
    <S.Header className={cn('card-header', className)} {...props}>
      {children}
    </S.Header>
  );
}

CardHeader.S = S;

CardHeader.propTypes = PropTypes.shape({
  children: PropTypes.node,
  className: PropTypes.string
});

export { CardHeader };
